import React from 'react';

export function MobilePhoneIcon(): JSX.Element {
  return (
    <svg fill='none' height='18' viewBox='0 0 18 18' width='18' xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M5.82044 2.64286C5.33038 2.64286 4.93312 3.02661 4.93312 3.5L4.9331 14.5C4.9331 14.9734 5.33037 15.3571 5.82042 15.3571H12.1796C12.6696 15.3571 13.0669 14.9734 13.0669 14.5L13.0669 3.5C13.0669 3.02661 12.6696 2.64286 12.1796 2.64286H5.82044ZM3.75002 3.5C3.75002 2.39543 4.67698 1.5 5.82044 1.5L12.1796 1.5C13.323 1.5 14.25 2.39543 14.25 3.5L14.25 14.5C14.25 15.6046 13.323 16.5 12.1796 16.5H5.82042C4.67696 16.5 3.75 15.6046 3.75 14.5L3.75002 3.5Z'
        fill='#121516'
        fillRule='evenodd'
      />
      <circle cx='9' cy='13.5' fill='#121516' r='0.75' />
    </svg>
  );
}
